var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "goUPDown goMessage" }, [
        _vm.scrollTop > 0 && !_vm.globalRfType
          ? _c("div", [
              _c("img", {
                staticClass: "goUP",
                attrs: { src: require("@/assets/goUP.svg") },
                on: {
                  click: function ($event) {
                    return _vm.scrollVal("top")
                  },
                },
              }),
              _c("img", {
                staticClass: "goDown",
                attrs: { src: require("@/assets/goDown.svg") },
                on: {
                  click: function ($event) {
                    return _vm.scrollVal("bottom")
                  },
                },
              }),
            ])
          : _vm._e(),
        _c("div", { staticClass: "msBox" }, [
          _c(
            "p",
            { staticClass: "insideMsBox", on: { click: _vm.lookMessage } },
            [
              _vm.noReadNum ? _c("i", { staticClass: "red-icon" }) : _vm._e(),
              _c("img", {
                staticClass: "message-icon",
                attrs: { src: require("@/assets/message.svg") },
              }),
            ]
          ),
        ]),
      ]),
      _c("message-notice", { ref: "messageNotice" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }